import React, { useState } from "react";

export default function ContactPage() {
  const [activeTab, setActiveTab] = useState("privacy");

  return (
    <div className="legal-container">
      {/* Tabs Navigation */}

      {/* Tabs Content */}
      <div className="tab-content">
        <p style={{fontSize:50,color:'black', fontWeight:'bolder', textAlign:'center', marginBottom:20,marginTop:20}}>CONTACT</p>
        <p className="mb-6">
        Have questions or need support? Feel free to reach out to us using the contact details below.
      </p>

      <div className="mb-6">
        <h2 className="text-xl font-semibold">Customer Support</h2>
        <p>Email: <a href="mailto:info@kelick.io" >info@kelick.io</a></p>
      </div>
      <div className="mb-6">
        <h2 className="text-xl font-semibold">Business Inquiries</h2>
        <p>Email: <a href="mailto:info@kelick.io" >info@kelick.io</a></p>
      </div>
      </div>

      {/* CSS Styles */}
      <style>{`
        .legal-container {
          max-width: 800px;
          margin: auto;
          font-family: Arial, sans-serif;
          padding: 20px;
        }
        .tab-buttons {
          display: flex;
          border-bottom: 2px solid #ddd;
        }
        .tab-buttons button {
          flex: 1;
          padding: 10px;
          border: none;
          background: #f4f4f4;
          cursor: pointer;
          font-size: 16px;
          font-weight: bold;
          transition: 0.3s;
        }
        .tab-buttons button.active {
          background: #02b9b0;
          color: white;
        }
        .tab-buttons button:hover {
          background: #ddd;
        }
        .tab-content {
          padding: 20px;
          background: #fff;
          border: 1px solid #ddd;
          margin-top: 10px;
        }
        .tab-content h1,.tab-content h2{
            font-weight: 900;
        }
        h2 {
          color: #333;
        }
        p {
          color: #555;
          line-height: 1.6;
        }
           
      `}</style>
    </div>
  );
}
